import Vue, { TrackOpTypes } from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')
const DashboardOriginal= () => import('@/views/DashboardOriginal')
const ControlPanel = () => import('@/views/ControlPanel')
//const DashboardIntranet = () => import('@/views/dash/Intranet')
const WebSocketSimple = () => import('@/views/SimpleWS')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Test = () => import('@/views/Test')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Switches = () => import('@/views/base/Switches')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Editors
const TextEditors = () => import('@/views/editors/TextEditors')
const CodeEditors = () => import('@/views/editors/CodeEditors')

// Views - Forms
const BasicForms = () => import('@/views/forms/BasicForms')
const AdvancedForms = () => import('@/views/forms/AdvancedForms')
const ValidationForms = () => import('@/views/forms/ValidationForms')

// Views GoogleMaps
const GoogleMaps = () => import('@/views/GoogleMaps')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')
const Toastr = () => import('@/views/notifications/Toastr')

// Views - Tables
const Tables = () => import('@/views/tables/Tables')
const DataTable = () => import('@/views/tables/DataTable')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const GiftList = () => import('@/views/pages/GiftList')

const ForgotPassword = () => import('@/views/pages/ForgotPassword')
const PasswordRecovery = () => import('@/views/pages/PasswordRecovery')
// Plugins
const Draggable = () => import('@/views/plugins/Draggable')
const Calendar = () => import('@/views/plugins/Calendar')
const Spinners = () => import('@/views/plugins/Spinners')

// Views - UI Kits
const Invoice = () => import('@/views/apps/invoicing/Invoice')
const Compose = () => import('@/views/apps/email/Compose')
const Inbox = () => import('@/views/apps/email/Inbox')
const Message = () => import('@/views/apps/email/Message')

// Controle de Troco
const ChangeControl = () => import('@/views/changecontrol/ChangeControl')
const ChangeReturn = () => import('@/views/changecontrol/ChangeReturn')
const ChangeOutgoing = () => import('@/views/changecontrol/ChangeOutgoing')
const DenominationExchange = () => import('@/views/changecontrol/DenominationExchange')
const ChangeMovementIn = () => import('@/views/changecontrol/MovementIn')
const ChangeMovementOut = () => import('@/views/changecontrol/MovementOut')


// Sistema
const SysCompany = () => import('@/views/sys/Company')
const SysUsers = () => import('@/views/sys/Users')

const SysAccess = () => import('@/views/sys/Access')
const SysAudit = () => import('@/views/sys/Audit')
const SysDepartment = () => import('@/views/sys/Department')
const SysJobPosition = () => import('@/views/sys/JobPosition')
const SysGroup = () => import('@/views/sys/Group')
const SysMailAccount = () => import('@/views/sys/MailAccount')
const SysMailServer = () => import('@/views/sys/MailServer')
const SysModule = () => import('@/views/sys/Module')
const SysTemplate = () => import('@/views/sys/Template')
const SysTeam = () => import('@/views/sys/Team')
const SysActivityBranch = () => import('@/views/sys/ActivityBranch')
const SysMenu = () => import('@/views/sys/Menu')

const Device = () => import('@/views/sys/Device')

const MeetingRoom = () => import('@/views/sys/MeetingRoom')

// Sistema Dados de Referência

const SysRefCountry = () => import('@/views/sysref/Country')
const SysRefStates = () => import('@/views/sysref/States')
const SysRefCity = () => import('@/views/sysref/City')
const PriceType = () => import('@/views/sysref/PriceType')
const UnitOfMeasurement = () => import('@/views/sysref/UnitOfMeasurement')

// Portal
const PrtDocuments = () => import('@/views/portal/Documents')
const PrtNews = () => import('@/views/portal/News')
const PrtBanner = () => import('@/views/portal/Banner')
const PrtLinks = () => import('@/views/portal/Links')
const PrtMedia = () => import('@/views/portal/Media')
const PrtPhonebook = () => import('@/views/portal/Phonebook')

// Pedido de Compra
const PurchaseApproval = () => import('@/views/purchase/PurchaseApproval')
const FinancialApproval = () => import('@/views/purchase/FinancialApproval')
const FinancialApprovalItem = () => import('@/views/purchase/FinancialApprovalItem')
const ITApproval = () => import('@/views/purchase/ITApproval')
const PurchaseOrder = () => import('@/views/purchase/PurchaseOrder')
const PurchaseRequest = () => import('@/views/purchase/PurchaseRequest')
//const Prospect = () => import('@/views/purchase/Prospect')
const QuoteMap = () => import('@/views/purchase/QuoteMap')
const Quotes = () => import('@/views/purchase/Quotes')
const SalesOrder = () => import('@/views/purchase/SalesOrder')

// Estoque
const Stock = () => import('@/views/stock/Stock')
const StockProduct = () => import("@/views/stock/StockProduct")
const StockLocation = () => import("@/views/stock/StockLocation")
const StockOperation = () => import("@/views/stock/StockOperation")

const Product = () => import('@/views/stock/Product')
const ProductBrand = () => import('@/views/stock/Brand')
const ProductCategory = () => import('@/views/stock/Category')
const ProductType = () => import('@/views/stock/ProductType')

// Inventário

const Inventory = () => import('@/views/inventory/Inventory')
const InventoryProduct = () => import('@/views/inventory/InventoryProduct')
const InventorySector = () => import('@/views/inventory/InventorySector')

const InventoryIdentification = () => import('@/views/inventory/InventoryIdentification')
const InventoryCounter = () => import('@/views/inventory/InventoryCounter')
const InventoryFiscal = () => import('@/views/inventory/InventoryFiscal')

const InventoryMonitor = () => import('@/views/inventory/InventoryMonitor')
const InventoryMonitorCount = () => import('@/views/inventory/InventoryMonitorCount')
const InventoryMonitorSector = () => import('@/views/inventory/InventoryMonitorSector')

const InventoryLabel = () => import('@/views/inventory/InventoryLabel')
const InventorySync = () => import('@/views/inventory/InventorySync')


// Recursos Humanos
const Quiz = () => import('@/views/humanresource/Quiz')
const QuizSummary = () => import('@/views/humanresource/QuizSummary')
const Game = () => import('@/views/humanresource/Game')
const HumanResourceSuggestion = () => import('@/views/humanresource/Suggestion')
const HumanResourceMood = () => import('@/views/humanresource/Mood')
const EPoint = () => import('@/views/humanresource/Epoint')

// Tarefas
const QuizUser = () => import('@/views/personal/QuizUser')
const MySuggestion = () => import('@/views/personal/MySuggestion')
const MyMood = () => import('@/views/personal/MyMood')
const MyEpoint = () => import('@/views/personal/MyEpoint')

// Financeiro
const FinAccountsDashboard = () => import('@/views/finance/AccountsDashboard')
const FinCostCenter = () => import('@/views/finance/CostCenter')
const FinAccountsPayable = () => import('@/views/finance/AccountsPayable')
const FinAccountsPayableFiles = () => import('@/views/finance/AccountsPayableFiles')
const FinAccountsReceivable = () => import('@/views/finance/AccountsReceivable')
const FinanceAccount = () => import('@/views/finance/Account')

// Frota
const FleetVehicle = () => import('@/views/fleetcontrol/FleetVehicle')

// Projetos / Obras
const Project = () => import('@/views/project/Project')
const ProjectSector = () => import('@/views/project/Sector')
const ProjectOccurrence = () => import('@/views/project/Occurrence')
const ProjectType = () => import('@/views/project/Type')
const ProjectFollowup = () => import('@/views/project/Followup')

// Pessoas
const Person = () => import('@/views/sys/Person')

// Rastrea
const RastreaJumper = () => import('@/views/rastrea/RastreaJumperAK2')
const RastreaJumperBatch = () => import('@/views/rastrea/RastreaJumperAK2Batch')
const RastreaJumperStation = () => import('@/views/rastrea/RastreaJumperAK2Station')
const RastreaBom = () => import('@/views/rastrea/RastreaBom')
const RastreaPart = () => import('@/views/rastrea/RastreaPart')

// CRM
const Crm = () => import('@/views/crm/Crm')
const CrmOrigin = () => import('@/views/crm/CrmOrigin')
const CrmStatus = () => import('@/views/crm/CrmStatus')
const CrmStatusFinal = () => import('@/views/crm/CrmStatusFinal')
const CrmType= () => import('@/views/crm/CrmType')

// Contratos
const Contract = () => import('@/views/contract/Contract')

// Desenvolvimento
const Development = () => import('@/views/dev/Development')
const SendPost = () => import('@/views/dev/SendPost')
const RestApiClient = () => import('@/views/dev/RestApiClient')

// MDFe
const MdfeMain = () => import('@/views/mdfe/MdfeMain')
const MdfeCertificate = () => import('@/views/mdfe/MdfeCertificate')
const MdfeConfiguration = () => import('@/views/mdfe/MdfeConfiguration')
const MdfeEnvironment = () => import('@/views/mdfe/MdfeEnvironment')
const MdfeRequests = () => import('@/views/mdfe/MdfeRequests')

// Franquia / Associação
const RegisterFranchise = () => import('@/views/pages/RegisterFranchise')
const FranchiseGroup = () => import('@/views/franchise/Group')
const FranchisePreference = () => import('@/views/franchise/Preference')
const FranchiseReferral = () => import('@/views/franchise/Referral')
const FranchiseRegistration = () => import('@/views/franchise/Registration')
const FranchiseAction = () => import('@/views/franchise/Action')

// Evento
const Event = () => import('@/views/event/Event')
const EventType = () => import('@/views/event/EventType')
const EventDate = () => import('@/views/event/EventDate')
const EventParticipant= () => import('@/views/event/EventParticipant')

// Freeflow
const FreeFlowDashboard = () => import('@/views/freeflow/Dashboard')
const FreeFlowTransaction = () => import('@/views/freeflow/Transaction')
const FreeFlowKpi = () => import('@/views/freeflow/Kpi')

//
const SlotMachine = () => import('@/views/gaming/SlotMachine')

// Dashboard
const TdshDashboard = () => import('@/views/tdsh/Dashboard')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/freeflow',
      redirect: '/dashboard',
      name: 'FreeFlow',
      component: DefaultContainer,      
      children: [
        {
          path: 'dashboard',
          name: 'Freeflow',
          component: FreeFlowDashboard
        },
        {
          path: 'transaction',
          name: 'Transações',
          component: FreeFlowTransaction
        },
        {
          path: 'kpi',
          name: 'KPI',
          component: FreeFlowKpi
        }
      ]
    },
    {
      path: '/adm',
      redirect: '/dashboard',
      name: 'Administrativo',
      component: DefaultContainer,
      children: [
        {
          path: 'contract',
          name: 'Contratos',
          component: Contract
        }
      ]
    },
    {
      path: '/event',
      redirect: 'event/event/',
      name: 'Eventos',
      component: DefaultContainer,      
      children: [
        {
          path: 'event',
          name: 'Evento',
          component: Event
        },
        {
          path: 'type',
          name: 'Tipos de Evento',
          component: EventType        
        },
        {
          path: 'date',
          name: 'Dados dos Eventos',
          component: EventDate          
        },
        {
          path: 'participant',
          name: 'Participantes do Evento',
          component: EventParticipant
        }
      ]
    },
    {
      path: '/franchise',
      redirect: '/dashboard',
      name: 'Associação',
      component: DefaultContainer,
      children: [
        {
          path: 'group',
          name: 'Grupos',
          component: FranchiseGroup
        },
        {
          path: 'referral',
          name: 'Indicações',
          component: FranchiseReferral
        },
        {
          path: 'preference',
          name: 'Preferências',
          component: FranchisePreference
        },
        {
          path: 'registration',
          name: 'Associados',
          component: FranchiseRegistration
        },
        {
          path: 'action',
          name: 'Ações',
          component: FranchiseAction
        }
      ]
    },
    {
      path: '/development',
      redirect: 'development/',
      name: 'Desenv',
      component: DefaultContainer,      
      children: [
        {
          path: '/',
          name: 'Desenvolvimento',
          component: Development          
        },
        {
          path: 'sendpost',
          name: 'Enviar Post',
          component: SendPost          
        },
        {
          path: 'restapiclient',
          name: 'Rest API Client',
          component: RestApiClient       
        }
      ]
    },
    {
      path: '/mdfe',
      redirect: '/dashboard',
      name: 'Portal MDFe',
      component: DefaultContainer,      
      children: [
        {
          path: 'main',
          name: 'MDFe',
          component: MdfeMain          
        },
        {
          path: 'certificate',
          name: 'Certificados',
          component: MdfeCertificate          
        },
        {
          path: 'config',
          name: 'Configuração',
          component: MdfeConfiguration          
        },
        {
          path: 'environment',
          name: 'Ambiente',
          component: MdfeEnvironment          
        },
        {
          path: 'requests',
          name: 'Consultas',
          component: MdfeRequests          
        }
      ]
    },
    {
      path: '/personal',
      redirect: '/dashboard',
      name: 'Pessoal',
      component: DefaultContainer,      
      children: [
        {
          path: 'quizuser',
          name: 'Meu Quiz',
          component: QuizUser,          
        },
        {
          path: 'mysuggestion',
          name: 'Minhas Sugestões',
          component: MySuggestion,          
        },
        {
          path: 'mymood',
          name: 'Meu Humor',
          component: MyMood,          
        },
        {
          path: 'myepoint',
          name: 'Meu Ponto Eletrônico',
          component: MyEpoint,          
        }
      ]
    },
    {
      path: '/projects',
      redirect: '/dashboard',
      name: 'Projetos',
      component: DefaultContainer,      
      children: [
        {
          path: 'project',
          name: 'Obra',
          component: Project
        },
        {
          path: 'sector',
          name: 'Setor',
          component: ProjectSector,          
        },
        {
          path: 'occurrence',
          name: 'Ocorrência',
          component: ProjectOccurrence,          
        },
        {
          path: 'type',
          name: 'Tipo de Projeto',
          component: ProjectType,          
        },
        {
          path: 'followup',
          name: 'Acompanhamento',
          component: ProjectFollowup,          
        }
      ]
    },
    {
      path: '/humanresource',
      redirect: '/dashboard',
      name: 'Recursos Humanos',
      component: DefaultContainer,      
      children: [
        {
          path: 'quiz',
          name: 'Quiz',
          component: Quiz,
        },
        
          {
            path: 'quizsummary',
            name: 'Questinários do Quiz',
            component: QuizSummary
          }
        ,
        {
          path: 'game',
          name: 'Gamificação',
          component: Game,          
        },
        {
          path: 'suggestion',
          name: 'Sugestão',
          component: HumanResourceSuggestion,          
        },
        {
          path: 'mood',
          name: 'Sentimento',
          component: HumanResourceMood,          
        },
        {
          path: 'epoint',
          name: 'Ponto Eletrônico',
          component: EPoint,          
        },
      ]
    },
    {
      path: '/crm',
      redirect: '/crm/crm',
      name: 'CRM',
      component: DefaultContainer,      
      children: [
        {
          path: 'crm',
          name: 'Relacionamento com o Cliente',
          component: Crm,
        },
        {
          path: 'origin',
          name: 'Origem',
          component: CrmOrigin,          
        },
        {
          path: 'status',
          name: 'Status',
          component: CrmStatus,          
        },
        {
          path: 'statusfinal',
          name: 'Status Final',
          component: CrmStatusFinal,          
        },
        {
          path: 'type',
          name: 'Tipo de evento CRM',
          component: CrmType,          
        }
      ]
    },
    {
      path: '/finance',
      redirect: '/finance/accountsdashboard',
      name: 'Financeiro',
      component: DefaultContainer,      
      children: [
        {
          path: 'accountsdashboard',
          name: 'Painel Financeiro',
          component: FinAccountsDashboard,
        },
        {
          path: 'accountspayablefiles',
          name: 'Contas a Pagar - Arquivos',
          component: FinAccountsPayableFiles,
        },
        {
          path: 'accountspayable',
          name: 'Contas a Pagar',
          component: FinAccountsPayable,
        },
        {
          path: 'accountsreceivable',
          name: 'Contas a Receber',
          component: FinAccountsReceivable,
        },
        {
          path: 'costcenter',
          name: 'Centro de Custo',
          component: FinCostCenter
        },
        {
          path: 'account',
          name: 'Contas',
          component: FinanceAccount
        }
        
      ]
    },
    {
      path: '/rastrea',
      redirect: '/dashboard',
      name: 'Rastrea',
      component: DefaultContainer,      
      children: [
        {
          path: 'jumper',
          name: 'Rastreabilidade por Código',
          component: RastreaJumper,
        },
        {
          path: 'jumperbatch',
          name: 'Rastreabilidade por Lote',
          component: RastreaJumperBatch,
        },
        {
          path: 'jumperstation',
          name: 'Rastreabilidade por Estação',
          component: RastreaJumperStation,
        },
        {
          path: 'bom',
          name: 'Lista de Materiais',
          component: RastreaBom,
        },
        {
          path: 'part',
          name: 'Lista de Peças',
          component: RastreaPart,
        }

      ]
    },
    {
      path: '/purchase',
      redirect: '/dashboard',
      name: 'Compras',
      component: DefaultContainer,      
      children: [
        {
          path: 'purchaseapproval',
          name: 'Aprovação Pedido Compra',
          component: PurchaseApproval,
          
        },
        {
          path: 'financialapproval',
          name: 'Aprovação Financeiro',
          component: FinancialApproval,
          
        },
        {
          path: 'financialapproval/item',
          name: "Aprovação Financeiro / Pedido de Compra",
          component: FinancialApprovalItem
        },
        {
          path: 'itapproval',
          name: 'Aprovação Técnica',
          component: ITApproval
        },
        {
          path: 'quotemap',
          name: 'Mapa de Cotações',
          component: QuoteMap
        },
        {
          path: 'purchaseorder',
          name: 'Pedidos de Compra',
          component: PurchaseOrder
        },
        {
          path: 'quotes',
          name: 'Cotações',
          component: Quotes
        },
        {
          path: 'salesorder',
          name: 'Ordem de Compra',
          component: SalesOrder
        },
        {
          path: 'purchaserequest',
          name: 'Solicitação de Compra',
          component: PurchaseRequest
        },
      ]
    },
    {
      path: '/',
      /* redirect: '/pages/login', */
      redirect: '/dashboard',
      name: 'Sistema',
      component: DefaultContainer,
      children: [
        /*
        {
          path: 'dashboard-finance',
          name: 'Dashboard Financeiro',
          component: TdshDashboard     
        },
        */
        {
          path: 'device',
          name: 'Dispositivos',
          component: Device
        },
        {
          path: 'meetingroom',
          name: 'Salas de Reunião',
          component: MeetingRoom
        },
        {
          path: 'person',
          name: 'Pessoas',
          component: Person
        },
        {
          path: 'dashboard',
          name: 'Portal',
          component: Dashboard
        },
        {
          path: 'dashboardoriginal',
          name: 'Portal Original',
          component: DashboardOriginal
        },
        {
          path: 'controlpanel',
          name: 'Área de Trabalho',
          component: ControlPanel
        },
        {
          path: 'simplews',
          name: 'Websocket',
          component: WebSocketSimple
        },
        {
          path: 'test',
          name: 'Test',
          component: Test
        },
        {
          path: 'product',
          name: 'Produtos',
          component: Product
        },
        {
          path: 'product/category',
          name: 'Categorias de Produtos',
          component: ProductCategory
        },
        {
          path: 'product/brand',
          name: 'Marcas de Produto',
          component: ProductBrand
        },
        {
          path: 'product/type',
          name: 'Tipo de Produtos',
          component: ProductType
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'sys',
          redirect: '/dashboard',
          name: 'Administração',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'user',
              name: 'Usuários',
              component: SysUsers
            },
            {
              path: 'company',
              name: 'Empresas',
              component: SysCompany
            },
            {
              path: 'department',
              name: 'Departamentos',
              component: SysDepartment
            },
            {
              path: 'jobposition',
              name: 'Cargo/Função',
              component: SysJobPosition
            },
            {
              path: 'activitybranch',
              name: 'Ramo de Atividade',
              component: SysActivityBranch
            },
            {
              path: 'audit',
              name: 'Auditoria',
              component: SysAudit
            },
            {
              path: 'mailserver',
              name: 'Servidor de e-mail',
              component: SysMailServer
            },
            {
              path: 'mailaccount',
              name: 'Contas de E-mail',
              component: SysMailAccount
            },
            {
              path: 'group',
              name: 'Grupos de Acesso',
              component: SysGroup
            },
            {
              path: 'team',
              name: 'Equipe',
              component: SysTeam
            },
            {
              path: 'access',
              name: 'Acessos',
              component: SysAccess
            },
            {
              path: 'module',
              name: 'Módulos',
              component: SysModule
            },
            {
              path: 'template',
              name: 'Modelos de Documento',
              component: SysTemplate
            },
            {
              path: 'menu',
              name: 'Menu',
              component: SysMenu
            }

          ]
        },
        {
          path: 'inventory',
          redirect: '/dashboard',
          name: 'Controle de Inventário',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'label',
              name: 'Etiquetas',
              component: InventoryLabel
            },
            {
              path: 'inventory',
              name: 'Inventário',
              component: Inventory
            },
            {
              path: 'product',
              name: 'Item',
              component: InventoryProduct
            },
            {
              path: 'sector',
              name: 'Setor / Área',
              component: InventorySector
            },
            {
              path: 'operation',
              name: 'Operação',
              component: StockOperation
            },
            {
              path: 'identification',
              name: 'Identificação de Peças',
              component: InventoryIdentification
            },
            {
              path: 'counter',
              name: 'Contagem de Itens',
              component: InventoryCounter
            },
            {
              path: 'fiscal',
              name: 'Contagem de Itens - Fiscal',
              component: InventoryFiscal
            },
            {
              path: 'monitor',
              name: 'Monitor',
              component: InventoryMonitor
            },
            {
              path: 'monitor-sector',
              name: 'Monitor por Setor',
              component: InventoryMonitorSector
            },
            {
              path: 'monitor-count',
              name: 'Contagem',
              component: InventoryMonitorCount
            },
            {
              path: 'sync',
              name: 'Sincronização',
              component: InventorySync
            }
          ]
        },

        {
          path: 'stock',
          redirect: '/dashboard',
          name: 'Controle de Estoque',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'stock',
              name: 'Estoque',
              component: Stock
            },
            {
              path: 'product',
              name: 'Produtos do Estoque',
              component: StockProduct
            },
            {
              path: 'inventory',
              name: 'Inventário de Produtos',
              component: Inventory
            },
            {
              path: 'location',
              name: 'Localização',
              component: StockLocation
            }
          ]
        },

        {
          path: 'fleetcontrol',
          redirect: '/dashboard',
          name: 'Controle de Frota',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'vehicle',
              name: 'Veículos',
              component: FleetVehicle
            }
          ]
        },
        {
          path: 'sysref',
          redirect: '/dashboard',
          name: 'Dados de Referência',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'country',
              name: 'Países',
              component: SysRefCountry
            },
            {
              path: 'states',
              name: 'Estados',
              component: SysRefStates
            },
            {
              path: 'city',
              name: 'Cidades',
              component: SysRefCity
            },
            {
              path: 'pricetype',
              name: 'Tipos de Preço',
              component: PriceType
            },
            {
              path: 'um',
              name: 'Unidade de Medida',
              component: UnitOfMeasurement
            },
          ]
        },
        {
          path: 'portal',
          redirect: '/dashboard',
          name: 'Portal Intranet',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'banner',
              name: 'Banner',
              component: PrtBanner
            },
            {
              path: 'documents',
              name: 'Documentos',
              component: PrtDocuments
            },
            {
              path: 'links',
              name: 'Links',
              component: PrtLinks
            },
            {
              path: 'media',
              name: 'Mídias',
              component: PrtMedia
            },
            {
              path: 'news',
              name: 'Notícias',
              component: PrtNews
            },
            {
              path: 'phonebook',
              name: 'Ramais',
              component: PrtPhonebook
            }
          ]
        },
        {
          path: 'changecontrol',
          redirect: '/changecontrol/changecontrol',
          name: 'Controle de Troco',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'changecontrol',
              name: 'Geral',
              component: ChangeControl
            },
            {
              path: 'changereturn',
              name: 'Retorno',
              component: ChangeReturn
            },
            {
              path: 'changeoutgoing',
              name: 'Nova Retirada',
              component: ChangeOutgoing
            }
            ,
            {
              path: 'denominationexchange',
              name: 'Troca de Denominação',
              component: DenominationExchange
            },
            {
              path: 'movementin',
              name: 'Entrada de Denominações',
              component: ChangeMovementIn
            },
            {
              path: 'movementout',
              name: 'Saída de Denominações',
              component: ChangeMovementOut
            },
          ]
        },
        {
          path: 'changecontrol',
          meta: { label: 'Controle de Troco'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ChangeControl,
            },
            {
              path: 'changereturn',
              redirect: '/changecontrol/ChangeControl',
              meta: { label: 'Retorno de Troco'},
              name: 'Retorno de Troco',
              component: ChangeReturn,
            },
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'editors',
          redirect: '/editors/text-editors',
          name: 'Editors',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'text-editors',
              name: 'Text Editors',
              component: TextEditors
            },
            {
              path: 'code-editors',
              name: 'Code Editors',
              component: CodeEditors
            }
          ]
        },
        {
          path: 'forms',
          redirect: '/forms/basic-forms',
          name: 'Forms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'basic-forms',
              name: 'Basic Forms',
              component: BasicForms
            },
            {
              path: 'advanced-forms',
              name: 'Advanced Forms',
              component: AdvancedForms
            },
            {
              path: 'validation-forms',
              name: 'Form Validation',
              component: ValidationForms
            }
          ]
        },
        {
          path: 'google-maps',
          name: 'Google Maps',
          component: GoogleMaps
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'toastr',
              name: 'Toastr',
              component: Toastr
            }
          ]
        },
        {
          path: 'plugins',
          redirect: '/plugins/draggable',
          name: 'Plugins',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'draggable',
              name: 'Draggable Cards',
              component: Draggable
            },
            {
              path: 'calendar',
              name: 'Calendar',
              component: Calendar
            },
            {
              path: 'spinners',
              name: 'Spinners',
              component: Spinners
            },
          ]
        },
        {
          path: 'tables',
          redirect: '/tables/tables',
          name: 'Tables',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'tables',
              name: 'Simple Tables',
              component: Tables
            },
            {
              path: 'data-table',
              name: 'Data Table',
              component: DataTable
            },
          ]
        },
        {
          path: 'apps',
          name: 'Apps',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'invoicing',
              redirect: '/apps/invoicing/invoice',
              name: 'Invoicing',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'invoice',
                  name: 'Invoice',
                  component: Invoice
                }
              ]
            },
            {
              path: 'email',
              redirect: '/apps/email/inbox',
              name: 'Email',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'compose',
                  name: 'Compose',
                  component: Compose
                },
                {
                  path: 'inbox',
                  name: 'Inbox',
                  component: Inbox
                },
                {
                  path: 'message',
                  name: 'Message',
                  component: Message
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'giftlist',
          name: 'Lista de Presentes',
          component: GiftList
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: { title: 'Skills - MyApp' }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'registerfranchise',
          name: 'RegisterFranchise',
          component: RegisterFranchise
        },
        {
          path: 'forgotpassword',
          name: 'Esqueci a Senha',
          component: ForgotPassword
        },
        {
          path: 'passwordrecovery',
          name: 'Recuperação de Senha',
          component: PasswordRecovery
        },
        {
          path: 'slotmachine',
          name: 'Slot Machine',
          component: SlotMachine          
        }
      ]
    }
  ]
})
